<article
  class="selected-item"
  [class.selected-item--with-plan]="costSummary?.isProtectionSelected"
>
  <figure class="selected-item__img">
    <img
      [src]="(data?.images && data.images[0]?.url) || imageNotAvailable"
      [attr.alt]="
        data?.images?.[0]?.text && data.images[0].text.trim()
          ? data.images[0].text
          : 'Replacement product: ' + data?.make 
      "
    />
  </figure>
  <section class="selected-item__content flex align--center">
    <div class="selected-item__description">
      <strong>Replacement cost</strong>
      <p
        class="selected-item__price"
        *ngIf="costSummary?.isProtectionSelected"
        [class.selected-item__price--free]="data?.upgrade_fee === 0"
      >
        {{ data?.upgrade_fee | currency : 'GBP' }}
      </p>
      <p>One-off payment</p>
    </div>
    <p
      class="selected-item__price"
      *ngIf="!costSummary?.isProtectionSelected"
      [class.selected-item__price--free]="data?.upgrade_fee === 0"
    >
      {{ data?.upgrade_fee | currency : 'GBP' }}
    </p>
  </section>
  <section
    class="selected-item__content selected-item__content--price flex align--center"
    *ngIf="costSummary?.isProtectionSelected"
  >
    <div class="selected-item__description">
      <strong>Protection policy</strong>
      <p
        class="selected-item__price"
        [class.selected-item__price--free]="data?.upgrade_fee === 0"
      >
        <span class="xs--block md--inline">{{
          costSummary?.monthlyPayment | currency : 'GBP'
        }}</span>
        <small class="xs--block md--inline">a month</small>
      </p>
      <p>Continuous cover</p>
    </div>
  </section>
</article>
